import React from 'react';
import { Modal, Divider, Button, Input, Radio, Message } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import CommonTable from '../../drive/Table/TableLayout';
import tableHeader from './playbookParticipants.json';
import { Form } from 'formsy-semantic-ui-react';
import { singleLineText } from '../../common/RegexValidation';
import { debounce } from "lodash";

class CopyPlaybookModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.selectedPracticeLibrary.name,
            tableHeader: tableHeader,
            _limit: 10,
            _sort: 'email',
            participantList: [],
            isParticipantsCheck: false
        }
    }

    handleClose = async (e) => {
        this.setState({
            participantList: [],
            isParticipantsCheck: false,
            name: this.props.selectedPracticeLibrary.name
        })
        this.props.handleCopyPlaybookModal(false);
    }

    handleCancle = (e) => {
        this.handleClose();
    }

    handleChangeName = (event) => {
        this.setState({ name: event.target.value.trim() })
        this.chekcNameAvailable(event.target.value.trim())
    };

    chekcNameAvailable = debounce(async (name) => {
        let duplicateName = this.props.allList.filter(pracName => pracName.name.split(" ").join("").toLowerCase() === name.toLowerCase()) 
        if(duplicateName.length > 0) {
            dispatch.lifeCycle.isPracticeAvailable(true)
        }
        if(duplicateName.length === 0) {
            dispatch.lifeCycle.isPracticeAvailable(false)
        }
    }, 300);

    handleSubmit = async (e) => {
        let participants = this.props.selectedSubOrg && this.filterParticipants(this.state.participantList)
        let payload = {
            _id: this.props.selectedPracticeLibrary._id,
            oldPlaybookName: this.props.selectedPracticeLibrary.name,
            name: this.state.name,
            // participants: this.state.participantList,
            participants: participants ? participants : this.state.participantList,
            accountId: this.props.selectedPracticeLibrary.accountId,
            organizationId: this.props.selectedPracticeLibrary.organizationId,
            copyMetaData:true
        }

        dispatch.lifeCycle.copyPlaybook(payload)
        this.handleClose();
    }

    handleTableComponent = (event, item, data) => {

        if (item.type === "radio") {
            if (item.checked) {
                const eIndex = this.state.participantList.findIndex(element => element.accountUserId == data.accountUserId)
                let pArray = [...this.state.participantList]
                pArray[eIndex] = { ...pArray[eIndex], role: item.value }
                this.setState({
                    participantList: pArray,
                });
            } else {
                const updateParticipantList = this.state.participantList.filter(item => item.accountUserId !== data.accountUserId);
                this.setState({ participantList: updateParticipantList });
            }
        } else if (item.type === "checkbox") {
            if (data.key === "checkbox") {
                this.setState({ participantList: [] });
                setTimeout(() => {
                    if (item.checked) {
                        let markAllParticipant = this.props.selectedPracticeLibrary.participants.filter((f, i) => { return (f.role !== "author" && f.accountUserId.toString() !== this.props.user._id.toString()) || (f.role === "author" && this.props.selectedOrganisation.role === 'workspaceOwner' && f.accountUserId.toString() !== this.props.user._id.toString()) })
                        this.setState({ participantList: markAllParticipant });
                    } else {
                        this.setState({ participantList: [], });
                    }
                }, 500);
            } else {
                if (item.checked) {
                    let p = {
                        accountUserId: data.accountUserId,
                        role: data.role,
                        name: data.name,
                        imageUrl: data.imageUrl,
                        email: data.email
                    }
                    this.setState({
                        participantList: [...this.state.participantList, p]
                    })
                } else {
                    const updateParticipantList = this.state.participantList.filter(item => item.accountUserId !== data.accountUserId);
                    this.setState({ participantList: updateParticipantList });
                }
            }
        }
        event.stopPropagation()

    }

    withParticipant = async(e, data) => {
        this.props.selectedPracticeLibrary.teamId && await dispatch.organizationUnit.getSubOrgByIdAsync(this.props.selectedPracticeLibrary.teamId);
        this.setState({ isParticipantsCheck: data.value, participantList: [] })
        if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants) {
            let markAllParticipant = this.props.selectedPracticeLibrary.participants
                .filter((f, i) => {
                    return (f.role !== "author" && f.accountUserId.toString() !== this.props.user._id.toString()) ||
                        (f.role === "author" && this.props.selectedOrganisation.role === 'workspaceOwner' && f.accountUserId.toString() !== this.props.user._id.toString())
                })
            markAllParticipant = this.props.selectedSubOrg ? this.filterParticipants(markAllParticipant) : markAllParticipant;      
            if (data.value) {
                this.setState({ participantList: markAllParticipant });
            } else {
                this.setState({ participantList: [] });
            }
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.props.selectedPracticeLibrary.name !== newProps.selectedPracticeLibrary.name) {
            this.setState({ name: newProps.selectedPracticeLibrary.name })
        }
    }

    filterParticipants(participants){
       return participants.filter(participant => {
            return this.props.selectedSubOrg.members.find(member => {
                return member.accountUserId.toString() === participant.accountUserId.toString();
            });
        });

    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const { selectedPracticeLibrary, routeParams, openCopyPlaybook, selectedOrganisation, user } = this.props
        const { tableHeader, name, _limit, _sort, participantList, isParticipantsCheck } = this.state

        let users = selectedPracticeLibrary &&
            selectedPracticeLibrary.participants &&
            selectedPracticeLibrary.participants.filter((f, i) => {
                return (f.role !== "author" && f.accountUserId.toString() !== this.props.user._id.toString()) ||
                    (f.role === "author" && selectedOrganisation.role === 'workspaceOwner' && f.accountUserId.toString() !== user._id.toString())
            })
            
        if (this.props.selectedSubOrg) {
            users = this.filterParticipants(users)
        }

        let disableParticipant =users && users.length === 0 ? true : false

        if (users) {
            for (let j = 0; j < users.length; j++) {
                if (users[j].role === 'author') {
                    users[j].role = "contributor"
                }
                users[j].updateParticipant = false;
                users[j].isRadioDisabled = true;
                users[j].updatedValue = users[j].role;
                if (participantList) {
                    for (let i = 0; i < participantList.length; i++) {
                        if (participantList[i].accountUserId === users[j].accountUserId) {
                            users[j].updateParticipant = true;
                            users[j].isRadioDisabled = false;
                            users[j].updatedValue = participantList[i].role;
                        }
                    }
                }
            }
        }

        let table = <CommonTable
            tableHeader={tableHeader}
            listData={users}
            limit={_limit}
            sort={_sort}
            copyPlaybook={true}
            selection={true}
            totalCount={users && users.length}
            handleTableComponent={this.handleTableComponent}
            routeParams={routeParams}
            onChangeLimit={this.onChangeLimit}
            refereshLocalData={false}
            defaultMarkAll={users && participantList && users.length === participantList.length ? true : false}
        />

        let changeName = <React.Fragment>
            <Form.Input
                required
                name="name"
                id="name"
                label="Name"
                validations={{ matchRegexp: singleLineText }}
                value={this.state.name}
                onChange={this.handleChangeName}
                errorLabel={errorLabel}
                validationErrors={{
                    matchRegexp: 'Max limit is 128. No space allowed in starting.',
                    isDefaultRequiredValue: 'Name is required',
                }}
                instantValidation
                autoFocus
            />
            {this.props.validPracticeName || name === selectedPracticeLibrary.name ?
                <div className="clr-red"
                    style={{ margin: "0 0 10px 0" }}>
                    Playbook with same name already exists. Please rename the playbook.</div>
                : null}
        </React.Fragment>

        let copyOrNot = <React.Fragment>
            <label className='required-field f_11'>Do you want to copy this Playbook? </label>
            <Form.Field >
                <Form.Radio
                    name='Participants'
                    label='With No Participants'
                    value={false}
                    checked={!isParticipantsCheck}
                    fluid
                    onChange={this.withParticipant}
                />
                <Form.Radio
                    name='Participants'
                    label='With Participants'
                    value={true}
                    disabled={disableParticipant}
                    checked={isParticipantsCheck}
                    onChange={this.withParticipant}
                />
                {disableParticipant ?
                    <Message
                        className="display-block"
                        error
                        content="No Participants to show."
                    />
                    : null}
            </Form.Field>
        </React.Fragment >

        let disableSubmitButton = !name ||this.props.validPracticeName ||
            (name === selectedPracticeLibrary.name) ||
            (isParticipantsCheck && participantList && participantList.length === 0)

        return (
            <Modal
                animated
                open={openCopyPlaybook}
                onClose={this.handleClose}
                size='small'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Modal.Header>
                    Copy Playbook
                </Modal.Header>
                <Divider style={{ margin: "10px 0 0px" }} />
                <Modal.Content scrolling>
                    <Form noValidate
                        id='copyPlay'
                        onValidSubmit={(data) => this.handleSubmit(data)}
                        className="formcyForm"
                    >
                        {changeName}
                        {copyOrNot} <br />
                    </Form>
                    {isParticipantsCheck ? table : null}
                </Modal.Content>

                <Modal.Actions className="actionInFormcy">
                    <Button
                        className="button-submit float-right"
                        id='copyPlaybook'
                        disabled={disableSubmitButton}
                        onClick={this.handleSubmit}
                    > Copy Playbook </Button>
                    <Button
                        id='copyCancel'
                        className="button-cancel"
                        onClick={this.handleClose}
                    > Cancel </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default CopyPlaybookModal;